import { HashRouter, Link, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import SiteInfo from './components/SiteInfo';
import InoueBingo from './components/old/Inoue Bingo';
import TakahashiBingo from './components/old/Takahashi Bingo';
import Reviews from './components/old/Reviews';
import Gradia from './components/old/Gradia';
import Links from './components/old/Links';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useRef, useState, useEffect } from 'react';

import { setupFragments, dockFragments} from "./js/functions.js";


function App() {
  
    useEffect(() => setupFragments(), [])
  const pages = {
    "Home": false,
    "Reviews": <Reviews />, 
    "InoueBingo": <InoueBingo />,
    "TakahashiBingo": <TakahashiBingo />, 
    "Gradia": <Gradia />, 
    "Links": <Links />
  }
  const [state, setState] = useState(0);
  const nodeRef = useRef(null);
  const [hoverMenuState, setHoverMenuState] = useState(true);
  const determineDockedMenu = () => {
    if(state !== 0){
      dockFragments()
    } else {
      setupFragments();
    }
  }
  return (
     <div className="App">
          <div id="siteInfoContainer">
          <SiteInfo setState={setState}/>
          </div>
          <div id="contentContainer">
            <div id="navContainer">
              <Home setState={setState}/>
            </div>
            <SwitchTransition mode='out-in'>
              <CSSTransition
                key={state}
                onEnter={() => determineDockedMenu()}
                nodeRef={nodeRef}
                timeout={501}
                classNames='slide'
              >
                <div ref={nodeRef}>
                  {pages[Object.keys(pages)[state]]}
                </div>
              </CSSTransition>
            </SwitchTransition>
          </div>
          <div id="asideContainer"></div>
    </div>
  );
}

export default App;
